import { forwardRef } from 'react';
import styled from 'styled-components';
import { color, display, space, system, typography } from 'styled-system';
import { HTMLKaajaProps } from '../../types';

type HeadingProps = HTMLKaajaProps<'h2'> & {
  whiteSpace?: string | string[];
};

const whiteSpace = system({
  whiteSpace: true,
});

const Styled = styled('h2')<HeadingProps>(
  (props) => ({
    fontWeight: 500,
    color: props.theme.colors.black,
    fontSize: props.theme.fontSizes[4],
    fontFamily: props.theme.fonts.heading,
    whiteSpace: 'pre-line',
  }),
  space,
  color,
  typography,
  display,
  whiteSpace
);

const Heading = forwardRef<HTMLHeadingElement, HeadingProps>((props, ref) => {
  const { ...rest } = props;

  return <Styled ref={ref} {...rest} />;
});

export { Heading };
